import { IOffer } from "@nju/data-access-portal-offers";
import { ZERO_OFFER_ID } from "./consts";

interface ISetZeroPackageProps {
  id: "VOICE_PACKAGE" | "DATA_PACKAGE";
}

export function setZeroPackage({ id }: ISetZeroPackageProps): IOffer {
  return {
    id: ZERO_OFFER_ID,
    productOfferingPrice: {
      price: {
        amount: 0,
      },
      priceType: "ONE-TIME",
    },
    balances: [
      {
        balanceId: "0",
        grantValue: "0",
      },
    ],
    productSpecificationId: id,
  };
}
